import { values } from 'lodash';

import socketPromise from '../../../websocket';

import { update } from '../../../modules/markets/actions/update';
import { bulk } from '../../../modules/selections/actions/update';
import { bulk as updateEvents } from '../../../modules/events/actions/update';

export function subscribe(dispatch, action) {
    socketPromise.then(socket => {
        action.ids.forEach(id => {
            socket.subscribe('*:Market:' + id, ({ body }) => {
                if (!body.market) {
                    return;
                }

                body = { ...body };
                body.id = body.market.id;

                let selections = values(body.selections);

                delete body.market;
                delete body.selections;

                if (body.event) {
                    dispatch(updateEvents([ body.event ]));
                }

                if('dividends' in body){
                    let newDividend = [];

                    newDividend['forecast'] = { ...body['dividends']['forecastDividend'] };
                    newDividend['tricast'] = { ...body['dividends']['tricastDividend'] };

                    body['dividends'] = { ...newDividend };

                }

                dispatch(bulk(selections));
                dispatch(update(body.id, body));
            });
        });
    });
}
